import { mediaList } from "@/mocks/media";
import { newsList } from "@/mocks/news";
import type { MediaItem, MediaType } from "@/types";

export function getMediaById(id: string): MediaItem | undefined {
  return mediaList.find((item) => item.id === id);
}

export function getMediaByType(type: MediaType): MediaItem[] {
  return mediaList.filter((item) => item.type === type);
}

export function getFeaturedMedia(): MediaItem[] {
  return mediaList.filter((item) => item.featured);
}

export function getLatestMedia(limit?: number): MediaItem[] {
  const sorted = [...mediaList].sort((a, b) => b.year - a.year || b.popularity - a.popularity);
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function getRelatedMedia(item: MediaItem, limit = 6): MediaItem[] {
  const scored = mediaList
    .filter((m) => m.id !== item.id)
    .map((m) => {
      let score = 0;
      if (m.type === item.type) score += 2;
      score += m.genres.filter((g) => item.genres.includes(g)).length * 3;
      score += m.tags.filter((t) => item.tags.includes(t)).length * 2;
      return { m, score };
    })
    .sort((a, b) => b.score - a.score || b.m.popularity - a.m.popularity);
  return scored.slice(0, limit).map((s) => s.m);
}

export function searchMedia(keyword: string): MediaItem[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return mediaList.filter((m) => {
    const haystack = [m.title, m.originalTitle, m.director, m.region, ...m.genres, ...m.tags, ...m.cast]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function getNewsById(id: string) {
  return newsList.find((n) => n.id === id);
}

export function searchNews(keyword: string) {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return newsList.filter((n) => {
    const haystack = [n.title, n.summary, n.category, ...n.tags].join(" ").toLowerCase();
    return haystack.includes(kw);
  });
}

export function getRelatedNews(id: string, limit = 3) {
  const current = newsList.find((n) => n.id === id);
  if (!current) return newsList.slice(0, limit);
  return newsList
    .filter((n) => n.id !== id)
    .sort((a, b) => {
      const sa = a.tags.filter((t) => current.tags.includes(t)).length;
      const sb = b.tags.filter((t) => current.tags.includes(t)).length;
      return sb - sa;
    })
    .slice(0, limit);
}